import { RevoltModal, RevoltButton } from '../../../components';
import './SaveErrorModal.css';

export function SaveErrorModal({
  isOpen,
  onClose,
  errorMessage,
  onRetry
}) {
  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Save Failed"
      containerClassName="save-error-modal"
    >
      <div className="save-error-content">
        <div className="save-error-icon">
          <i className="fa-solid fa-triangle-exclamation"></i>
        </div>
        <p className="save-error-message">
          {errorMessage || 'Failed to save configuration. The request may have timed out or encountered an error.'}
        </p>
        <div className="save-error-actions">
          <RevoltButton variant="outline" onClick={onClose}>
            Close
          </RevoltButton>
          {onRetry && (
            <RevoltButton variant="accent" onClick={onRetry}>
              Retry
            </RevoltButton>
          )}
        </div>
      </div>
    </RevoltModal>
  );
}
